<template>
  <van-swipe class="com-banner wow animate__fadeIn" data-wow-duration="3s" :show-indicators="false" :height="height" v-if="bannerList.length">
    <van-swipe-item v-for="(banner, index) in bannerList" :key="index">
      <img :src="$joinImgPrefix(banner.src)" :class="`com-banner-img ${banner.url ? 'link' : ''}`" @click="openLink(banner.url)"/>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import { WOW } from 'wowjs'
  export default {
    props: {
      urls: {
        type: Array,
        default () {
          return null
        }
      },
      bannerType: {
        type: [Number, String],
        default () {
          return 1
        }
      },
      height: {
        type: Number,
        default () {
          return 300
        }
      }
    },
    data () {
      return {
        bannerList: []
      }
    },
    mounted () {
      if (!this.urls) {
        this.getBanner()
      } else {
        this.eachBanner()
      }
      var wow = new WOW({
        animateClass: 'animate__animated'
      })
      wow.init()
    },
    watch: {
      urls: {
        handler () {
          this.eachBanner()
        },
        deep: true
      },
      '$route' () {
        this.getBanner()
      }
    },
    methods: {
      // 数据格式化
      eachBanner () {
        this.bannerList = this.urls.map(v => {
          if (typeof v === 'string') {
            return {
              src: v
            }
          }
          return v
        })
      },
      // 轮播图
      getBanner () {
        this.bannerList = []
        if (this.$route.meta.cId) {
          this.$columnApi.getColumn({
              cId: this.$route.meta.cId
          }).then(res => {
            if (res.success) {
              this.bannerList = [{
                src: res.data.mobilePicUrl
              }]
            }
          })
        }
      },

      openLink (url) {
        if (url) {
          window.location.href = url
        }
      }
    }
  }
</script>
